import { render, staticRenderFns } from "./ProcesoCompraConRecinto.vue?vue&type=template&id=67a206ef"
import script from "./ProcesoCompraConRecinto.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraConRecinto.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompraConRecinto.vue?vue&type=style&index=0&id=67a206ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports